<template>
  <v-container fluid>
    <v-card>
      <v-tabs color="#0482fb" right>
        <v-tab>Agence</v-tab>
        <v-tab>Utilisateur</v-tab>
        <v-tab>Produit</v-tab>
        <v-tab>Compagnie</v-tab>

        <v-tab-item key="1">
          <v-container v-if="Agencies && Agencies.docs" fluid>
            <v-data-table
              class="pt-3"
              flat
              :headers="headersAgency"
              :items="Agencies.docs"
              :items-per-page="5"
              sort-by="country"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Management Agence</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="AgencyDialog" max-width="900px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                       
                        color="#0482fb"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Ajouter nouvelle agence
                      </v-btn>
                    </template>
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title>
                        <span class="text-h5">{{ AgencyForm }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="agencyModal.name"
                                label="Nom de l'argence"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="agencyModal.country"
                                label="Pays"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="agencyModal.phone"
                                label="Téléphone"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="agencyModal.email"
                                label="Mail"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="error"
                          right
                          text
                          @click="closeAgencyForm"
                        >
                          Fermer
                        </v-btn>
                        <v-btn
                         
                          color="success"
                          class="mr-6"
                          right
                          :loading="loading ? '#0482fb' : null"
                          @click="saveAgencyForm"
                        >
                          Enregistrer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="agencyDeleteDialog" max-width="500px">
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this
                        item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="closeAgencyForm"
                          >Annuler</v-btn
                        >
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="confirmDeleteAgency"
                          :loading="loading ? '#0482fb' : null"
                          >Supprimer</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editAgency(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="initDeleteAgency(item._id)"> </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                 
                  color="error"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item key="2">
          <v-container v-if="Users && Users.docs" fluid>
            <v-data-table
              class="pt-3"
              flat
              :headers="headersUsers"
              :items="Users.docs"
              :items-per-page="5"
              sort-by="calories"
            >
              <template v-slot:item.agency="{ item }">
                <td>
                  {{ item.agency && item.agency.name }}
                </td>
              </template>

              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title
                    >Management compte utilisateur</v-toolbar-title
                  >
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="userDialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                       
                        color="#0482fb"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Ajouter un utilisateur
                      </v-btn>
                    </template>
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title>
                        <span class="text-h5">Utilisateur</span>
                      </v-card-title>

                      <v-card-text>
                        <v-form>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.lastName"
                                  label="Nom"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.firstName"
                                  label="Prénoms"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.email"
                                  label="Email"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.phone"
                                  label="Téléphone"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-select
                                  outlined
                                  :items="agencyNameList"
                                  v-model="userModal.agency"
                                  flat
                                  label="Agence"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.currentPosition"
                                  label="Poste"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.username"
                                  label="Nom d'utilisateur"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  outlined
                                  color="#0482fb"
                                  v-model="userModal.password"
                                  label="Mots de passe"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="error"
                          right
                          text
                          @click="userDialog = false"
                        >
                          Fermer
                        </v-btn>
                        <v-btn
                         
                          color="success"
                          class="mr-6"
                          right
                          @click="saveNewUsers"
                        >
                          Enregistrer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this
                        item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editUsersItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small> </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                 
                  color="error"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item key="3">
          <v-container v-if="Products && Products.docs" fluid>
            <v-data-table
              class="pt-3"
              flat
              :headers="headersProduct"
              :items="Products.docs"
              :items-per-page="5"
              sort-by="calories"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Management Produit</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="productDialog" width="1000px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                       
                        color="#0482fb"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Ajouter produit
                      </v-btn>
                    </template>
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="8">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="productModal.name"
                                label="Nom"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="productModal.acronym"
                                label="Abreviation"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="productModal.description"
                                label="Description"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-file-input
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Pick an avatar"
                                prepend-icon="mdi-camera"
                                label="Icon"
                                v-model="productModal.icon"
                              ></v-file-input>
                            </v-col>
                            <v-col cols="12">
                              <quill-editor
                                ref="editor"
                                v-model="productModal.text"
                                class="mt-5"
                                :options="editorOption"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="error"
                          right
                          text
                          @click="closeAgencyForm"
                        >
                          Fermer
                        </v-btn>
                        <v-btn
                         
                          color="success"
                          class="mr-6"
                          right
                          :loading="loading ? '#0482fb' : null"
                          @click="saveProductForm"
                        >
                          Enregistrer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="productDeleteDialog" max-width="500px">
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this
                        item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="closeAgencyForm"
                          >Cancel</v-btn
                        >
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="confirmDeleteProduct"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editProduct(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="initDeleteProduct(item._id)"> </v-icon>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item key="4">
          <v-container v-if="Companies && Companies.docs" fluid>
            <v-data-table
              class="pt-3"
              flat
              :headers="headersCompany"
              :items="Companies.docs"
              :loading="loading ? '#0482fb' : null"
              :items-per-page="5"
              sort-by=""
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title
                    >Management compagnie d'assurance</v-toolbar-title
                  >
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="companyDialog" max-width="1000px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                       
                        color="#0482fb"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Ajouter une compagnie
                      </v-btn>
                    </template>
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.name"
                                label="Nom"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.country"
                                label="Pays"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.email"
                                label="Email"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.responsibleName"
                                label="Nom du responsable"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.service"
                                label="Service"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.nomination"
                                label="Nomination"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.address"
                                label="Adresse"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.province"
                                label="Province"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.NIF"
                                label="NIF"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.STAT"
                                label="STAT"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-text-field
                                outlined
                                color="#0482fb"
                                v-model="companyModal.RCS"
                                label="RCS"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-container class="grey lighten-5">
                                <v-data-table
                                  style="text-align:right;"
                                  :headers="correspondant"
                                  :items="corresspondantData"
                                >
                                  <template v-slot:item.actions="{ item }">
                                    <v-row>
                                      <v-icon
                                        color="warning"
                                        @click="editCorrespondant(item)"
                                      >
                                        mdi-pencil-box-multiple-outline</v-icon
                                      >

                                      <v-icon
                                        @click="deletCorrespondant(item)"
                                        class="ml-10"
                                        size="30"
                                        color="error"
                                        >mdi-delete-empty</v-icon
                                      >
                                    </v-row>
                                  </template>

                                  <template v-slot:top>
                                    <v-toolbar flat>
                                      <v-toolbar-title
                                        >Correspondants</v-toolbar-title
                                      >
                                      <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                      ></v-divider>
                                      <v-spacer></v-spacer>
                                      <v-dialog
                                        v-model="correspondantModal"
                                        max-width="500px"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-btn
                                           
                                            color="#0482fb"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                          >
                                            <v-icon left>
                                              mdi-account-outline
                                            </v-icon>
                                            Ajouter un correspondant
                                          </v-btn>
                                        </template>
                                        <v-card
                                          style="border-top: 10px solid #0482fb"
                                          max-width="500px"
                                        >
                                          <v-card-title>
                                            <span class="text-h5">{{
                                              correspondantTitle
                                            }}</span>
                                          </v-card-title>

                                          <v-card-text>
                                            <v-container>
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field
                                                    outlined
                                                    color="#0482fb"
                                                    v-model="
                                                      correspondantItem.firstName
                                                    "
                                                    label="Nom"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field
                                                    outlined
                                                    color="#0482fb"
                                                    v-model="
                                                      correspondantItem.lastName
                                                    "
                                                    label="Prénoms"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="12">
                                                  <v-text-field
                                                    outlined
                                                    color="#0482fb"
                                                    v-model="
                                                      correspondantItem.phone
                                                    "
                                                    type="number"
                                                    label="Phone"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field
                                                    outlined
                                                    color="#0482fb"
                                                    v-model="
                                                      correspondantItem.currentPosition
                                                    "
                                                    label="Poste Actuel"
                                                  ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field
                                                    outlined
                                                    color="#0482fb"
                                                    v-model="
                                                      correspondantItem.email
                                                    "
                                                    type="mail"
                                                    label="Mail"
                                                  ></v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>

                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                             
                                              color="error"
                                              right
                                              text
                                              @click="correspondantClose"
                                            >
                                              Fermer
                                            </v-btn>
                                            <v-btn
                                             
                                              color="success"
                                              class="mr-6"
                                              right
                                              @click="addPersonnel"
                                            >
                                              Ajouter
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                      <v-dialog
                                        v-model="correspondantModalDelete"
                                        max-width="500px"
                                      >
                                        <v-card
                                          style="border-top: 10px solid #0482fb"
                                        >
                                          <v-card-title class="text-h5"
                                            >Are you sure you want to delete
                                            this item?</v-card-title
                                          >
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                             
                                              color="blue darken-1"
                                              text
                                              @click="closeDelete"
                                              >Cancel</v-btn
                                            >
                                            <v-btn
                                             
                                              color="blue darken-1"
                                              text
                                              @click="correspondantConfirm"
                                              >OK</v-btn
                                            >
                                            <v-spacer></v-spacer>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </v-toolbar>
                                  </template>
                                </v-data-table>
                              </v-container>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="error"
                          right
                          text
                          @click="closeAgencyForm"
                        >
                          Fermer
                        </v-btn>
                        <v-btn
                         
                          color="success"
                          class="mr-6"
                          right
                          :loading="loading ? '#0482fb' : null"
                          @click="saveCompanyForm"
                        >
                          Enregistrer
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="companyDeleteDialog" max-width="500px">
                    <v-card style="border-top: 10px solid #0482fb">
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this
                        item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                         
                          color="blue darken-1"
                          text
                          @click="closeAgencyForm"
                          >Cancel</v-btn
                        >
                        <v-btn
                         
                          color="blue darken-1"
                          :loading="loading ? '#0482fb' : null"
                          text
                          @click="confirmDeleteCompany"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editCompany(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="initDeleteCompany(item._id)"> </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                 
                  color="error"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import {
  addAgency,
  updateAgency,
  deleteAgency,
  updateProduct,
  addProduct,
  deleteProduct,
  updateCompany,
  addCompany,
  deleteCompany,
  addUsers,
  updateUsers,
} from "@/api/admin";
export default {
  components: { quillEditor },
  data: () => ({
    dialog: false,
    loading: false,
    AgencyDialog: false,
    newagentArray: [],
    agenceName: "",
    agencyNameList: [],
    dialogDelete: false,
    headersAgency: [
      {
        text: "Nom de l'argence",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Localité", value: "country" },
      { text: "Téléphone", value: "phone" },
      { text: "Mail", value: "email" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersUsers: [
      {
        text: "Nom",
        align: "start",
        sortable: true,
        value: "lastName",
      },
      { text: "Prénoms", value: "firstName" },
      { text: "Téléphone", value: "phone" },
      { text: "Mail", value: "email" },
      { text: "Agence", value: "agency" },
      { text: "Poste", value: "currentPosition" },
      { text: "Nom d'utilisateur", value: "username" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersProduct: [
      {
        text: "Nom du produit",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "Abréviation", value: "acronym" },
      { text: "Description", value: "description" },
      { text: "Rapels avis échéance", value: "dueDate" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersCompany: [
      {
        text: "Nom de la compagnie",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Pays", value: "country" },
      { text: "Mail", value: "email" },
      { text: "Nomination", value: "nomination" },
      { text: "Nom responsable", value: "responsibleName" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    agencies: [],
    editedIndex: -1,
    editedItem: {
      nom: "",
      localisation: "",
      telephone: "",
      mail: "",
    },
    defaultItem: {
      nom: "",
      localisation: "",
      telephone: "",
      mail: "",
    },
    editorOption: {
      // Some Quill options...
      theme: "snow",

      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
          ["link", "image", "video"],
        ],
      },
    },
    correspondantModal: false,
    correspondantModalDelete: false,
    correspondant: [
      {
        text: "Nom",
        align: "start",
        sortable: false,
        value: "firstName",
      },
      { text: "Prénoms", value: "lastName" },
      { text: "Téléphone", value: "phone" },
      { text: "Poste actuel", value: "currentPosition" },
      { text: "Mail", value: "email" },
      { text: "Actions", align: "right", value: "actions" },
    ],
    corresspondantData: [],
    correspondantIndex: -1,
    correspondantItem: {
      firstName: "",
      lastName: "",
      phone: "",
      currentPosition: "",
      email: "",
    },
    corresspondantdefaultItem: {
      firstName: "",
      lastName: "",
      phone: "",
      currentPosition: "",
      email: "",
    },
    loader: false,
    agencyModal: {},
    agencyDeleteDialog: false,
    userModal: {},

    productModal: {},
    productDialog: false,
    productDeleteDialog: false,

    companyModal: {
      name: "",
      country: "",
      email: "",
      responsibleName: "",
      service: "",
      nomination: "",
      agents: [],
    },
    companyDialog: false,
    companyDeleteDialog: false,
    userDialog: false,
  }),

  computed: {
    ...mapGetters(["Agencies", "Users", "Products", "Companies"]),
    AgencyForm() {
      return this.editedIndex === -1 ? "Ajouter Agence" : "Modifier Agence";
    },
    formTitle() {
      return this.editedIndex === -1 ? "Enregistrement " : "Modification ";
    },
    correspondantTitle() {
      return this.correspondantIndex === -1
        ? "Ajouter un correspondant"
        : "Modifier informations correspondant";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Agencies() {
      this.agencyNameList = defaultMethods.getNameList(this.Agencies.docs);
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions(["getAgencies", "getUsers", "getProducts", "getCompanies"]),
    async initialize() {
      try {
        await this.initAgencies();
        await this.initProducts();
        await this.initCompanies();
        await this.initUsers();
      } catch (error) {
        console.log(error);
      }
    },
    // agency
    async initAgencies() {
      this.loading = true;
      try {
        await this.getAgencies();
        console.log(this.Agencies.docs);
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les agences")
        );
      }
      this.loading = false;
    },
    closeAgencyForm() {
      this.agencyModal = {};
      this.productModal = {};
      this.companyModal = {};
      this.userDialog = {};
      this.userDialog = false;
      this.AgencyDialog = false;
      this.agencyDeleteDialog = false;
      this.productDialog = false;
      this.productDeleteDialog = false;
      this.companyDialog = false;
      this.companyDeleteDialog = false;
      this.editedIndex = -1;
    },
    async saveAgencyForm() {
      this.loading = true;
      try {
        if (this.agencyModal.id) {
          // update
          await updateAgency({
            schema: {
              name: this.agencyModal.name,
              country: this.agencyModal.country,
              phone: this.agencyModal.phone,
              email: this.agencyModal.email,
            },
            id: this.agencyModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("L'agence")
          );
          this.closeAgencyForm();
          this.initAgencies();
        } else {
          // add
          await addAgency(this.agencyModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("L'agence")
          );
          this.closeAgencyForm();
          this.initAgencies();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    editAgency(item) {
      this.editedIndex = 1;
      this.agencyModal = {
        name: item.name,
        id: item._id,
        country: item.country,
        phone: item.phone,
        email: item.email,
      };
      this.AgencyDialog = true;
    },
    initDeleteAgency(id) {
      this.agencyModal = {
        id,
      };
      this.agencyDeleteDialog = true;
    },
    async confirmDeleteAgency() {
      this.loading = true;
      try {
        // add
        await deleteAgency({
          id: this.agencyModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("L'agence")
        );
        this.closeAgencyForm();
        this.initAgencies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // product
    async initProducts() {
      this.loading = true;
      try {
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les produits")
        );
      }
      this.loading = false;
    },
    async saveProductForm() {
      this.loading = true;
      try {
        const formData = new FormData();
        if (this.productModal.icon) {
          formData.append("icon", this.productModal.icon);
        }
        formData.append("name", this.productModal.name);
        formData.append("acronym", this.productModal.acronym);
        formData.append("description", this.productModal.description);
        formData.append("text", this.productModal.text);

        if (this.productModal.id) {
          // update
          await updateProduct({
            schema: formData,
            id: this.productModal.id,
          });

          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Le produit")
          );
          this.closeAgencyForm();
          this.initAgencies();
        } else {
          // add
          await addProduct({ schema: formData, });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Le produit")
          );
          this.closeAgencyForm();
          this.initProducts();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    editProduct(item) {
      this.editedIndex = 1;
      this.productModal = {
        name: item.name,
        id: item._id,
        description: item.description,
        dueDate: item.dueDate,
        acronym: item.acronym,
        icon: item.icon,
        text: item.text,
      };
      this.productDialog = true;
    },
    initDeleteProduct(id) {
      this.productModal = {
        id,
      };
      this.productDeleteDialog = true;
    },
    async confirmDeleteProduct() {
      this.loading = true;
      try {
        // add
        await deleteProduct({
          id: this.productModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("Le produit")
        );
        this.closeAgencyForm();
        this.initAgencies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // company
    async initCompanies() {
      this.loading = true;
      try {
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les compagnies")
        );
      }
      this.loading = false;
    },
    async saveCompanyForm() {
      this.loading = true;
      this.companyModal.agents = this.corresspondantData;
      try {
        if (this.companyModal.id) {
          // update

          await updateCompany({
            schema: {
              name: this.companyModal.name,
              country: this.companyModal.country,
              email: this.companyModal.email,
              service: this.companyModal.service,
              nomination: this.companyModal.nomination,
              responsibleName: this.companyModal.responsibleName,
              agents: this.companyModal.agents,
              address: this.companyModal.address,
              province: this.companyModal.province,
              NIF: this.companyModal.NIF,
              STAT: this.companyModal.STAT,
              RCS: this.companyModal.RCS,
            },
            id: this.companyModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("La compagnie")
          );
          this.closeAgencyForm();
          this.initCompanies();
        } else {
          // add
          await addCompany(this.companyModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("La compagnie")
          );
          this.closeAgencyForm();
          this.initCompanies();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    editCompany(item) {
      console.log(item);
      this.editedIndex = 1;
      this.newagentArray = [];
      for (let a = 0; a < item.agents.length; a++) {
        this.newagentArray.push({
          firstName: item.agents[a].firstName,
          lastName: item.agents[a].lastName,
          phone: item.agents[a].phone,
          currentPosition: item.agents[a].currentPosition,
          email: item.agents[a].email,
        });
      }
      this.companyModal = Object.assign(
        {},
        {
          id: item._id,
          name: item.name,
          country: item.country,
          email: item.email,
          service: item.service,
          nomination: item.nomination,
          address: item.address,
          province: item.province,
          NIF: item.NIF,
          STAT: item.STAT,
          RCS: item.RCS,
          responsibleName: item.responsibleName,
          agents: this.newagentArray,
        }
      );
      this.corresspondantData = this.companyModal.agents;

      this.companyDialog = true;
    },
    initDeleteCompany(id) {
      this.companyModal = {
        id,
      };
      this.companyDeleteDialog = true;
    },
    async confirmDeleteCompany() {
      this.loading = true;
      try {
        // add
        await deleteCompany({
          id: this.companyModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("La compagnie")
        );
        this.closeAgencyForm();
        this.initCompanies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    // user
    async initUsers() {
      this.loading = true;
      try {
        await this.getUsers();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les utilisateurs")
        );
      }
      this.loading = false;
    },

    editItem(item) {
      this.editedIndex = this.agencies.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.AgencyDialog = true;
    },
    editUsersItem(item) {
      this.editedIndex = 1;
      console.log(item.agency.name);
      this.userModal = {
        lastName: item.lastName,
        firstName: item.firstName,
        email: item.email,
        phone: item.phone,
        agency: item.agency.name,
        id: item._id,
        username: item.username,
        currentPosition: item.currentPosition,
      };
      //alert(this.userModal.agency);
      this.userDialog = true;
    },
    async saveNewUsers() {
      this.loading = true;
      try {
        if (this.userModal.id) {
          // update
          this.userModal.agency = await updateUsers({
            schema: {
              lastName: this.userModal.lastName,
              firstName: this.userModal.firstName,
              email: this.userModal.email,
              phone: this.userModal.phone,
              agency: defaultMethods.getItemId(
                this.Agencies.docs,
                this.userModal.agency
              ),
              currentPosition: this.userModal.currentPosition,
              password: this.userModal.password,
              username: this.userModal.username,
            },
            id: this.userModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("L'utilisateur")
          );
          this.closeAgencyForm();
          this.initUsers();
        } else {
          // add
          this.userModal.agency = defaultMethods.getItemId(
            this.Agencies.docs,
            this.userModal.agency
          );

          await addUsers(this.userModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("L'utilisateur")
          );
          this.closeAgencyForm();
          this.initUsers();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    deleteItem(item) {
      this.editedIndex = this.agencies.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.agencies.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.agencies[this.editedIndex], this.editedItem);
      } else {
        this.agencies.push(this.editedItem);
      }
      this.close();
    },
    //Corresspondant
    editCorrespondant(item) {
      this.correspondantIndex = this.corresspondantData.indexOf(item);
      this.correspondantItem = Object.assign({}, item);
      this.correspondantModal = true;
    },

    deletCorrespondant(item) {
      this.correspondantIndex = this.corresspondantData.indexOf(item);
      this.correspondantItem = Object.assign({}, item);
      this.correspondantModalDelete = true;
    },

    correspondantConfirm() {
      this.corresspondantData.splice(this.correspondantIndex, 1);
      this.correspondantDelete();
    },

    correspondantClose() {
      this.correspondantModal = false;
      this.$nextTick(() => {
        this.correspondantItem = Object.assign(
          {},
          this.corresspondantdefaultItem
        );
        this.correspondantIndex = -1;
      });
    },

    correspondantDelete() {
      this.correspondantModalDelete = false;
      this.$nextTick(() => {
        this.correspondantItem = Object.assign(
          {},
          this.corresspondantdefaultItem
        );
        this.correspondantIndex = -1;
      });
    },
    addPersonnel() {
      if (this.correspondantIndex > -1) {
        Object.assign(
          this.corresspondantData[this.correspondantIndex],
          this.correspondantItem
        );
      } else {
        this.corresspondantData.push(this.correspondantItem);
      }
      this.correspondantClose();
    },
  },
};
</script>
